(function () {
  const originalFetch = window.fetch;

  window.fetch = function (input, init) {
    let url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;

    if (url && url.includes('/search/suggest')) {
      // Thêm variants.sku vào fields nếu chưa có
      if (url.includes('fields=') && !url.includes('variants.sku')) {
        url = url.replace(/fields=([^&]+)/, function (match, fields) {
          return 'fields=' + fields + ',variants.sku';
        });
      }

      // Trường hợp không có fields parameter → thêm mới
      if (!url.includes('fields=')) {
        url += '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';
      }

      // Rebuild input nếu cần
      if (typeof input === 'string') {
        input = url;
      } else if (input instanceof URL) {
        input = new URL(url);
      } else {
        input = new Request(url, input);
      }
    }

    return originalFetch.call(this, input, init);
  };
})();